import publisher from '@/api/publisher'
import file from '@/api/file'
import mauthor from '@/api/mauthor'
export default {
  data() {
    return {
      publisher: {},
      article: {
        journal: {}
      },
      domain: ''
    }
  },
  mounted() {
    let publisherId = ''
    // if (!location.hostname.includes('192.168')) {
    //   publisherId = location.hostname.split('.')[0]
    // }
    let { id } = this.$route.params
    this.id = id
    this.getPublisherInfo(publisherId || 'imr')
    this.getArticle(id)
    this.getDomain()
  },
  methods: {
    async getPublisherInfo(id) {
      this.publisher = await publisher.query(id)
    },
    async getArticle(id) {
      try {
        this.article = await mauthor.manuscript(id)
      } catch (e) {
        this.$router.push('/other-author/notice/' + id)
      }
    },
    async getDomain() {
      this.domain = await file.domain()
    },
    async decision(id) {
      try {
        await mauthor.decision(id, {
          status: 'DECLINED'
        })
        this.$message.success({
          title: 'Success',
          content: 'Thank you for your submit!'
        })
      } catch (e) {
        this.$router.push('/other-author/notice/' + id)
      }
    },
    confirm() {
      this.decision(this.id)
    },
    cancel() {
      window.location.href = this.publisher.website
    }
  }
}
